module.exports = __webpack_public_path__ + "media/charte_selection/arrow3-9f1d06df.png";